import { render } from "./StarChartSetup.vue?vue&type=template&id=27da6390&scoped=true"
import script from "./StarChartSetup.vue?vue&type=script&lang=js"
export * from "./StarChartSetup.vue?vue&type=script&lang=js"

import "./StarChartSetup.vue?vue&type=style&index=0&id=27da6390&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27da6390"]])

export default __exports__